
// @contactCenter
const actionTypes = require('constants/contactCenter/actionTypes');

//@core
const { formatText } = require('core/i18n').i18n;

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const Storage = require('utilities/storage')
const {validateDNI, validateCIF} = require('utilities/contactCenter/identificationNumberChecker');

//@constants
const { AGENT_INFO } = require('constants/session');
const { ERROR_DOCUMENT_NOT_FOUND, ERROR_INVALID_DOCUMENT } = require('constants/contactCenter/errorTypes');
const { FIRST_STEP } = require('constants/index');
const { DEFAULT_ORIGIN_COUNTRY } = require('constants/countries');

const searchClientFetching = () => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_CLIENT_FETCHING
});

const searchClientUpdateCountry = country => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_CLIENT_UPDATE_COUNTRY,
    payload: {
        country
    }
})

const searchClientFailure = errorMessage => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_CLIENT_FAILURE,
    payload: {
        errorMessage
    }
});

const searchClientSuccess = response => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_CLIENT_SUCCESS,
    payload: {
        response
    }
});

const searchClientUnrecoverableError = () => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_UNRECOVERABLE_ERROR,
});

const getErrorMessage = errorCode => {
    let errorMessage = '';
    switch(errorCode) {

        case ERROR_DOCUMENT_NOT_FOUND:
            errorMessage = formatText('stepClientSearch-errorDocumentNotFound');
            break;

        case ERROR_INVALID_DOCUMENT:
            errorMessage = formatText('stepClientSearch-errorDocumentInvalid');
            break;

        default:
            errorMessage = formatText('stepClientSearch-errorDocumentNotFound')
            break;
    }

    return errorMessage;
};


const confirmClientSearch = (documentType, document, country = DEFAULT_ORIGIN_COUNTRY) => (dispatch, getState) => {
    const isAlreadyFetching = getState().customerFinder.getIn(['steps', FIRST_STEP, 'isFetching']);
    const agentInfo = JSON.parse(Storage.cookies.get(AGENT_INFO));
    let errorMessage;

    if (documentType === 'N') {
        if (!validateDNI(document)) {
            errorMessage = formatText('stepClientSearch-errorDocumentInvalid');
            dispatch(searchClientFailure(errorMessage));
            return;
        }
    } else if(documentType === 'S') {
        if(!validateCIF(document)){
            errorMessage = formatText('stepClientSearch-errorDocumentInvalid');
            dispatch(searchClientFailure(errorMessage));
            return;
        }
    }

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                bankToken: agentInfo.bankToken,
                document,
                documentType
            }
        }

        dispatch(searchClientFetching());
        dispatch(searchClientUpdateCountry(country));

        return APIPost(dispatch, apiURLBuilder.getURL('clientidentification'), requestData)
            .then( response => dispatch(searchClientSuccess(response)))
            .catch( error => {
                const status = error.error.status;
                errorMessage = getErrorMessage(error.error);

                if ( status == 400 ) {
                    dispatch(searchClientFailure(errorMessage));
                } else {
                    dispatch(searchClientUnrecoverableError())
                }
            })
    }
};

const resetErrorMessage = () => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_CLEAN_ERROR_MESSAGE,
});

const showEmptyDocumentError = () => ({
    type: actionTypes.CUSTOMER_FINDER_SEARCH_EMPTY_DOCUMENT,
    payload: {
        errorMessage: getErrorMessage(ERROR_INVALID_DOCUMENT)
    }
});

module.exports = {
    confirmClientSearch,
    resetErrorMessage,
    showEmptyDocumentError,
}
